import { type RouteObject } from 'react-router'

/**
 * Creates routes for the account management feature.
 */
export function createRoutes(): RouteObject[] {
  return [
    {
      path: '/account',
      lazy: {
        Component: () =>
          import('@/features/account/AccountView/AccountViewContainer').then(
            (r) => r.default,
          ),
      },
      children: [
        {
          path: 'personal-info',
          lazy: {
            Component: () =>
              import('./PersonalInfoView/PersonalInfoViewContainer').then(
                (r) => r.default,
              ),
          },
        },
        {
          path: 'billing',
          lazy: {
            Component: () =>
              import('./PaymentsView/PaymentsViewContainer').then(
                (r) => r.default,
              ),
          },
        },
        {
          path: 'security',
          lazy: {
            Component: () =>
              import('./SecurityView/SecurityViewContainer').then(
                (r) => r.default,
              ),
          },
        },
      ],
    },
  ]
}
